<template>
  <div>
    <el-card v-loading="loading" class="box-card">
      <div slot="header" class="box-header">
        <div class="box-header__title">Настройка push-уведомления</div>
        <div class="box-header__counter">
          <span class="box-header__counter_accent">{{ countUser }}</span> пользователей найдено по этому фильтру
        </div>
      </div>

      <div class="description">Пожалуйста, заполните поля ниже, чтобы отфильтровать список пользователей которым будет
        отправлено пуш уведомление
      </div>

      <el-form ref="main-form" :rules="mainFormRules" :model="push" v-if="push" class="main-form">
        <el-form-item label="Заголовок" prop="push_title">
          <el-input name="title" autosize placeholder="Введите заголовок..." v-model="push.push_title"></el-input>
        </el-form-item>
        <el-form-item label="Текст уведомления" prop="push_body">
          <el-input
            size="medium"
            v-model="push.push_body"
            maxlength="255"
            name="title"
            type="textarea"
            autosize
            placeholder="Введите описание..."
          ></el-input>
        </el-form-item>
        <el-form-item label="Целевой экран" prop="screen_id">
          <el-select v-model="push.screen_id" class="main-form__select">
            <el-option
              v-for="item in mobileScreensList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-row :gutter="16" type="flex" align="bottom" class="coords">
          <el-col :span="6">
            <el-form-item label="Координаты" prop="lat">
              <el-input
                @input="(v) => this.push.lat = v.replace(',', '.')"
                v-model="push.lat"
                class="coords__item append">
                <div slot="suffix">Широта</div>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="" prop="lng">
              <el-input
                @input="(v) => this.push.lng = v.replace(',', '.')"
                v-model="push.lng"
                class="coords__item append">
                <div slot="suffix">Долгота</div>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="Радиус" prop="radius">
              <el-input @input="(v) => this.push.radius = v.replace(',', '.')"
                        v-model="push.radius"
                        class="coords__item append">
                <div slot="suffix">Км</div>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="" prop="">
              <el-link type="primary" @click="addCoord()" class="coord-link">Москва и область</el-link>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="16">
          <el-col :span="12">
            <el-form-item label="Дата последнего входа в приложение" prop="last_visit_day">
              <el-input
                @input="(v) => this.push.last_visit_day = v.replace(',', '.')"
                v-model="push.last_visit_day"
                class="last-date__item append">
                <div slot="suffix">Более чем, дней</div>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="Дата последнего скрининга" prop="last_screening_day">
              <el-input
                @input="(v) => this.push.last_screening_day = v.replace(',', '.')"
                v-model="push.last_screening_day"
                class="last-date__item append">
                <div slot="suffix">Более чем, дней</div>
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item label="Теги целевых пользователей" prop="questionnaire_list_id">
          <el-select v-model="push.questionnaire_list_id" @change="changeQuestionnaireId" class="main-form__select">
            <el-option
              v-for="item in questionnaireList"
              :key="item.id"
              :label="item.title"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-cascader
          v-if="!loading"
          v-model="push.questions_id"
          style="width: 100%"
          :options="getQuestionsCascader"
          :props="props"
          clearable
          placeholder="Выбор тегов"
          expandTrigger="hover"
        />

        <el-form-item label="Пол" prop="last_visit_day">
          <el-checkbox-group v-loading="genderLoading" v-model="push.gender" class="gender-list">
            <div v-for="item in genderList" :key="item.id">
              <el-checkbox-button :label="item.id"
                                  :value="item.id"
                                  :key="item.id">
                {{ item.title }}
              </el-checkbox-button>
            </div>
          </el-checkbox-group>
        </el-form-item>

        <div class="buttons">
          <el-button
            v-if="pushId"
            :loading="loadMainForm"
            @click="sendForm('update')"
            class="buttons__btn"
            type=""
            icon="el-icon-check"
          >Обновить
          </el-button>
          <el-button
            v-else
            :loading="loadMainForm"
            @click="sendForm('create')"
            class="buttons__btn"
            type=""
            icon="el-icon-check"
          >Сохранить
          </el-button>
          <el-button
            :loading="loadMainForm"
            @click="sendForm('countUser')"
            class="buttons__btn"
            type=""
            icon="el-icon-view"
          >Посчитать пользователей
          </el-button>
          <el-button
            :loading="loadMainForm"
            @click="sendForm('send', true)"
            class="buttons__btn"
          >Отправить тестовой группе
          </el-button>
          <el-button
            @click="sendConfirm"
            :loading="loadMainForm"
            slot="reference"
            class="buttons__btn"
            type="primary"
          >Отправить ({{ countUser || '-' }} человек)
          </el-button>
        </div>
      </el-form>
    </el-card>

  </div>
</template>

<script>
export default {
  name: 'cpanel.push.new',
  data () {
    const validateLastVisitDay = (rule, value, callback) => {
      const geo = ((this.push.lat) || (this.push.lng) || (this.push.radius))
      if (!value && !(this.push.last_screening_day) && !(this.push.questionnaire_list_id) && !geo) {
        callback(new Error('Укажите это поле или другие'))
      } else if ((isNaN(value)) && value) callback(new Error('Укажите только цифры')); else callback()
    }
    const validateLastScreeningDay = (rule, value, callback) => {
      const geo = ((this.push.lat) || (this.push.lng) || (this.push.radius))
      if (!value && !(this.push.last_visit_day) && !(this.push.questionnaire_list_id) && !geo) {
        callback(new Error('Укажите это поле или другие'))
      } else if ((isNaN(value)) && value) callback(new Error('Укажите только цифры')); else callback()
    }

    const validateQuestionnaireList = (rule, value, callback) => {
      const geo = ((this.push.lat) || (this.push.lng) || (this.push.radius))
      if (!value && !(this.push.last_visit_day) && !(this.push.last_screening_day) && !geo) {
        callback(new Error('Укажите это поле или другие'))
      } else {
        callback()
      }
    }

    const validateGeo = (rule, value, callback) => {
      const geo = (!!(this.push.lat) && !!(this.push.lng) && !!(this.push.radius))
      const files = !(this.push.last_visit_day) && !(this.push.last_screening_day) && !(this.push.questionnaire_list_id)
      if (!geo && files && !value) callback(new Error('Укажите это поле')); else if ((isNaN(value)) && value) callback(new Error('Укажите только цифры')); else callback()
    }

    return {
      props: { multiple: true },
      pushId: this.id,
      genderList: [],
      genderLoading: false,
      loadData: null,
      loading: false,
      push: {
        questionnaire_list_id: 0,
        questions_id: [],
        gender: [],
        screen_id: '',
        lat: null,
        lng: null,
        radius: null
      },
      questionnaireList: {},
      mobileScreensList: {},
      countUser: 0,
      serviceModal: false,
      questionAddModal: false,
      questionEditModal: false,
      loadMainForm: false,
      loadDeleteForm: false,
      loadTable: false,
      errorLoadCard: false,
      departments: {
        title: null,
        description: null
      },
      selectDevice: null,
      error: null,
      mainFormRules: {
        push_title: [
          {
            validator: (rule, value, callback) => {
              if (!value) callback(new Error('Укажите это поле')); else callback()
            },
            trigger: 'blur'
          }
        ],
        push_body: [
          {
            validator: (rule, value, callback) => {
              if (!value) callback(new Error('Укажите это поле')); else callback()
            },
            trigger: 'blur'
          }
        ],
        lat: [
          {
            validator: validateGeo,
            trigger: 'blur'
          }
        ],
        lng: [
          {
            validator: validateGeo,
            trigger: 'blur'
          }
        ],
        radius: [
          {
            validator: validateGeo,
            trigger: 'blur'
          }
        ],
        last_visit_day: [
          {
            validator: validateLastVisitDay,
            trigger: 'blur'
          }
        ],
        last_screening_day: [
          {
            validator: validateLastScreeningDay,
            trigger: 'blur'
          }
        ],
        questionnaire_list_id: [
          {
            validator: validateQuestionnaireList,
            trigger: 'blur'
          }
        ],
        questions_id: [
          {
            required: true,
            message: 'Укажите значение',
            trigger: 'blur'
          }
        ],
        screen_id: [
          {
            required: true,
            message: 'Укажите значение',
            trigger: 'blur'
          }
        ]
      }
    }
  },
  created () {
    this.loading = true
    this.loadLogic()
  },
  props: {
    id: {}
  },
  watch: {
    push () {
      this.$refs['main-form'].clearValidate()
    }
  },
  computed: {
    getQuestionsCascader () {
      if (!this.push.questionnaire_list_id) return []
      const options = this.findQuestions(this.push.questionnaire_list_id).questions
      if (!options) return []

      const fun = (options) => options.map(item => {
        if (item.children.length) {
          return {
            value: item.id,
            label: item.schema.text,
            children: fun(item.children)
          }
        } else {
          return {
            value: item.id,
            label: item.schema.text
          }
        }
      })
      return fun(options)
    },
    ruteCoods () {
      return (!!(this.push.lat) && !!(this.push.lng) && !!(this.push.radius))
    }
  },
  components: {},
  methods: {
    changeQuestionnaireId () {
      this.loading = true

      this.$nextTick(() => {
        this.push.questions_id = []
        this.loading = false
      })
    },
    addCoord () {
      console.log('push')
      this.push.lat = '55.7522200'
      this.push.lng = '37.6155600'
      this.push.radius = '200.0'
    },
    log (q, w) {
      this.push.radius = q.replace(',', '.')
    },
    findQuestions (id) {
      if (!this.questionnaireList.length) return []
      return this.questionnaireList.find(element => element.id === id)
    },
    loadLogic () {
      this.getQuestionnaireList()
      this.getMobileScreens()
      this.getGenderList()
      if (this.pushId) this.getPush()
    },
    getGenderList () {
      this.genderLoading = true
      this.$api.question
        .getCompendium('gender')
        .then((response) => {
          this.genderList = response.data.data
        })
        .catch(() => {
          this.$notify.error({
            title: 'Упс...',
            message: 'Ошибка всязи'
          })
        })
        .finally(() => {
          this.genderLoading = false
        })
    },
    fun (options) {
      // todo убрать это!
      let arr = options.filter(item => item.selected).map(item => {
        if (item.children.length) {
          const a = []
          item.children.forEach(ch => {
            if (ch.selected) a.push([item.id, ch.id])
          })
          return a
        } else {
          return [item.id]
        }
      })
      arr = arr.flat()
      return arr.map(item => {
        if (item.length) {
          return item
        } else {
          return [item]
        }
      })
    },
    getPush () {
      this.$api.push
        .view(this.pushId)
        .then((response) => {
          this.push = { ...response.data, ...this.push }
          // this.push.questions_id = []
          this.push.screen_id = response.data.screen.id
          this.push.gender = response.data.gender

          if (response.data.questionnaire) {
            const options = response.data.questionnaire.questions
            this.push.questions_id = this.fun(options)
            this.push.questionnaire_list_id = response.data.questionnaire.id
          }

          this.$forceUpdate()

          this.$nextTick(() => {
            this.sendForm('countUser')
          })
        })
        .catch((response) => {
          this.$notify.error({
            title: 'Ошибка загрузки модели',
            message: response.data.message
          })
        })
        .finally(() => {
          this.loading = false
        })
    },
    getQuestionnaireList () {
      this.loading = true
      this.$api.push
        .getQuestionnaireList()
        .then((response) => {
          this.questionnaireList = response.data
        })
        .catch((response) => {
          this.$notify.error({
            title: 'Ошибка загрузки списка анкет',
            message: response.data.message
          })
        })
        .finally(() => {
          this.loading = false
        })
    },
    getMobileScreens () {
      this.loading = true
      this.$api.push
        .getMobileScreens()
        .then((response) => {
          this.mobileScreensList = response.data
        })
        .catch((response) => {
          this.$notify.error({
            title: 'Ошибка загрузки списка целевых экранов',
            message: response.data.message
          })
        })
        .finally(() => {
          this.loading = false
        })
    },
    sendConfirm () {
      const h = this.$createElement
      this.$msgbox({
        title: 'Отправить?',
        message: h('p', null, [
          h('span', null, 'Вы действительно хотите создать и отправить '),
          h('b', null, this.countUser),
          h('span', null, ' пользователям?')
        ]),
        customClass: 'my-delete',
        showCancelButton: true,
        confirmButtonText: 'Отправить',
        cancelButtonText: 'Отменить',
        beforeClose: (action, instance, done) => {
          if (action === 'confirm') {
            this.sendForm('send')
            done()
          } else {
            done()
          }
        }
      }).then((action, instance) => {

      })
    },
    sendForm (method, test) {
      let validation = false

      this.$refs['main-form'].validate((valid, data) => {
        validation = valid
      })
      if (!validation) return document.querySelector('#main-block').scroll(0, 0)

      let payLoad = { ...this.push, ...{ questions_id: [...new Set(this.push.questions_id.flat(Infinity))] } }

      if (method === 'send') {
        if (test) {
          payLoad = {
            params: {
              test: true
            }
          }
        }
        if (!this.pushId) {
          return this.$notify.warning({
            title: 'Ошибка',
            message: 'Сохраните шаблон перед отправкой'
          })
        }
      }

      this.loading = true
      this.$api.push[method](payLoad, this.pushId)
        .then((response) => {
          let message = 'Успешно отправлено'
          if (method === 'countUser') {
            this.countUser = response.data.count
            message = `Найдено пользователей: <b>${response.data.count}</b>`
          }
          if (method === 'create') {
            message = 'Фильтр создан'
            this.pushId = response.data.id
          }

          this.$notify.success({
            dangerouslyUseHTMLString: true,
            title: 'Успешно',
            message
          })
        })
        .catch((response) => {
          this.$notify.error({
            title: 'Ошибка запроса',
            message: response.message
          })
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>

<style scoped lang="scss">
// todo вынести это, сделать подключаемым
.append /deep/ {
  .el-input__suffix-inner div {
    padding-right: 8px;
  }
}

.box-card {
  max-width: 960px;
  margin: 10px auto;

  &__title {
    font-style: normal;
    font-weight: bold;
    font-size: 16px;
    line-height: 19px;
    color: #aaaeba;
    margin: 5px 0 40px 0;
  }

  &__btns {
    text-align: center;
    margin: 50px 0 0 0;
  }
}

.description {
  margin: 4px 0 24px 0;
  font-size: 15px;
  color: #909399;

}

.coords {

  &__item {
    width: 216px;
  }
}

.box-header {
  display: flex;
  justify-content: start;
  align-items: center;
  gap: 16px;

  &__title {
    font-weight: bold;
    font-size: 15px;
    line-height: 18px;
    color: #303133;
  }

  &__counter {
    font-size: 15px;
    color: #909399;

    &_accent {
      font-weight: bold;
      color: #5AC9AD;
      font-size: 16px;
    }
  }

}

.buttons {
  margin-top: 24px;
  padding-top: 24px;
  border-top: 1px solid #DCDFE6;

  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;

  &__btn {
    width: 100%;
  }
}

.last-date {
  &__item {
    width: 100%;
  }
}

.main-form {
  width: 100%;

  &__select {
    width: 100%;
  }
}

.gender-list {
  display: flex;
  margin: 10px 0;
  width: 100%;
}

.coord-link {
  line-height: 1;
  margin-left: 10px;
}
</style>
